/**
 * What a past visit shows, section by section, with the line each section shows when the job has
 * nothing for it. Desktop's `JobHistoryDetail` and the phone's visit sheet both read from here.
 */
export const VISIT_DETAIL_SECTIONS = {
  serviceNeeded: { title: 'Service Needed', empty: 'No description provided.' },
  jobNotes: { title: 'Job Notes', empty: 'No job notes.' },
  partsUsed: { title: 'Parts Used', empty: 'N/A' },
  equipment: { title: 'Equipment Serviced', empty: 'No equipment information available.' },
  notes: { title: 'Notes', empty: 'No notes for this job.' },
} as const;

export const VISIT_FACT_LABELS = {
  date: 'Date',
  job: 'Job',
  status: 'Status',
  technician: 'Technician',
  labor: 'Labor',
} as const;

export const laborHoursLabel = (hours: number) => `${hours.toFixed(2)} hours`;
